import { defineComponent as _defineComponent } from 'vue'
import {ref} from "vue";
import {useUserStore} from "@/store/user.store";
import dataService from '@/services/data.service';
import { VoteOption } from "@/models/store/proposal";
import KeplrLogo from "../commons/KeplrLogo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'VoteModal',
  props: {
    title: { type: String, required: true },
    proposalId: { type: Number, required: true }
  },
  emits: ['close'],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();


const err = ref();

const props = __props;
const emit = __emit;

const picked = ref<VoteOption>();

const changeVotingOption = (option: VoteOption) => {
  picked.value = option;
};

const onVoteClick = () => {
  if (picked.value !== undefined){
    useUserStore().vote(picked.value, props.proposalId);
    emit('close');

  } else {
    err.value='err';
  }
};

const __returned__ = { err, props, emit, picked, changeVotingOption, onVoteClick, get useUserStore() { return useUserStore }, get dataService() { return dataService }, get VoteOption() { return VoteOption }, KeplrLogo }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})